import { eq } from "drizzle-orm";
import { clientPayments } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { postDocument, type DocumentMovements } from "../posting.js";
import { recordPosting } from "../audit.js";

type Db = TestDb;

export function buildClientPaymentMovements(input: {
  counterpartyId: string; cashAccountId: string; amountKopecks: number; cashflowCategoryId?: string;
}): DocumentMovements {
  return {
    settlement: [{ counterpartyId: input.counterpartyId, amountDeltaKopecks: -input.amountKopecks }],
    cash: [{ cashAccountId: input.cashAccountId, amountDeltaKopecks: input.amountKopecks, cashflowCategoryId: input.cashflowCategoryId }],
  };
}

export async function postClientPayment(db: Db, paymentId: string, actorId: string): Promise<void> {
  const [pay] = await db.select().from(clientPayments).where(eq(clientPayments.id, paymentId));
  if (!pay) throw new Error(`CLIENT_PAYMENT_NOT_FOUND: ${paymentId}`);
  const movements = buildClientPaymentMovements({
    counterpartyId: pay.counterpartyId,
    cashAccountId: pay.cashAccountId,
    amountKopecks: pay.amountKopecks,
    cashflowCategoryId: pay.cashflowCategoryId ?? undefined,
  });
  await postDocument(db, { docType: "client_payment", docId: pay.id, date: pay.date }, movements);
  await recordPosting(db, { actorId, docType: "client_payment", docId: pay.id, action: "post" });
}
